export default "__VITE_ASSET__BUloF2kA__"